import { useEffect, useState } from "react";

const BOOKING_URL =
  "https://app.squareup.com/appointments/book/l9pvy8kdwl7zdo/LNYM6MCNQE0AX/start";

// Mon–Sat 07:00–21:00, Central Time
function isOpenNow() {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/Chicago",
    weekday: "short",
    hour: "numeric",
    hourCycle: "h23",
  }).formatToParts(new Date());
  const day = parts.find((p) => p.type === "weekday").value;
  const hour = Number(parts.find((p) => p.type === "hour").value);
  return day !== "Sun" && hour >= 7 && hour < 21;
}

export default function HoursBadge({ testId, className = "" }) {
  const [open, setOpen] = useState(isOpenNow);

  useEffect(() => {
    const id = setInterval(() => setOpen(isOpenNow()), 60000);
    return () => clearInterval(id);
  }, []);

  const base = `inline-flex items-center gap-2 border-2 border-black px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.2em] font-semibold whitespace-nowrap ${className}`;

  if (open) {
    return (
      <span data-testid={testId} data-open="true" className={`${base} bg-white text-black`}>
        <span className="relative flex w-2.5 h-2.5">
          <span className="absolute inset-0 rounded-full bg-green-500 animate-ping opacity-75" />
          <span className="relative w-2.5 h-2.5 rounded-full bg-green-600" />
        </span>
        Open now
      </span>
    );
  }
  return (
    <a
      href={BOOKING_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      data-open="false"
      className={`${base} bg-white text-black hover:bg-black hover:text-white transition-colors`}
    >
      <span className="w-2.5 h-2.5 rounded-full bg-zinc-400 border border-black" />
      Closed – book online
    </a>
  );
}
